import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/pro-light-svg-icons';
import CustomToast from '../../../../../../components/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import QuestionsClipboardModal from './components/questionsClipboardModal';
import QuestionTypes from '../../../../../../enums/questionTypes';
import AddQuestionsToAssignment from '../../../addQuestionsToAssignment';
import { useAddQuestionsMutation } from '../../../../../../features/authentication/questionSearchApiSlice';
import { useAssignmentContext } from '../../../../../assignments/context';
import AssignmentStatus from '../../../../../../enums/assignmentStatus';
import AddQuestionsToExisting from './components/addQuestionsToExisting';
import { DataProvider } from '../../../../../assignments/DataContext';
import AssignmentCreateContent from '../../../../../assignments/components/AssignmentCreateContent';
import MathSkillQuestionThumbnail from '../../../mathSkills/MathSkillQuestionThumbnail';
import Modal from '../../../../../../../src/components/Modal';
import { useAddMathSkillQuestionsMutation } from '../../../../../../features/authentication/assignmentApislice';
import { useQuestionSearchContext } from '../../context';
import PageNavigation from '../../../../../../components/pageNavigation';
import CreateQuestionSetModel from '../../../../../myContent/pages/questionSets/components/CreateQuestionSetModel';
import { useAddCastleQuestionsToQSetMutation, useAddMathSkillQuestionsToQSetMutation } from '../../../../../../features/authentication/qSetApiSlice';

const DetailsBar = (props) => {
  const { assignmentId, from, qSetId } = useParams();
  const [showClipboardModal, setShowClipboardModal] = useState(false);
  const [openOptionTileModal, setOpenOptionTileModal] = useState(false);
  const [dateBasedKey] = useState(new Date().getTime().toString());
  const [selectedQTypeFilter, setSelectedQTypeFilter] = useState('all');
  const [disableQuestionPerPages, setDisableQuestionPerPages] = useState(false);
  const [openQsetCreateModal, setOpenQsetCreateModal] = useState(false);
  

  const [addQuestions] = useAddQuestionsMutation();
  const [addMathSkillQuestions] = useAddMathSkillQuestionsMutation();
  const [addMathSkillQuestionsToQSet] = useAddMathSkillQuestionsToQSetMutation();
  const navigate = useNavigate();
  const { mcChoices, assignmentAssignedViaDetails, setAssignmentAssignedViaDetails } = useAssignmentContext();
  const [showMathSkillClipBoard, setShowMathSkillClipBoard] = useState(false);
  const questionSearchContext = useQuestionSearchContext();
  const [addCastleQuestionsToQSet] = useAddCastleQuestionsToQSetMutation();

  const handleSelectPage = (pageNumber) => {
    if (pageNumber == props.selectedPage) return;
    props.getPageCastleQuestionsCall({ pageNumber: pageNumber, pageSize: props.questionsPerPage }).then((results) => { props.MapSearchResults(results, false); });
    props.setSelectedPage(pageNumber);
  };

  const saveComponentAddToExisting = <AddQuestionsToExisting key={'update' + dateBasedKey}
    handleSave={(id) => addQuestionsToExistingAssignment(id, false)}
    handleCancel={() => setOpenOptionTileModal(false)} />;

  const saveComponentCreate = <DataProvider>
    <AssignmentCreateContent
      key={'create' + dateBasedKey}
      showBrowseContent={false}
      showTitle={false} showCancelButton={true}
      handleCancel={() => setOpenOptionTileModal(false)}
      onCreateSuccess={(id, assignedViaDetails) => addQuestionsToExistingAssignment(id, true, assignedViaDetails)}
    />
  </DataProvider>;

  const handleAddQuestions = async () => {
    if (!props.selectedQuestions || props.selectedQuestions.length == 0) {
      CustomToast('Please select questions to add', 'error');
      return;
    }
    if (props.selectedQuestions.length > 100) {
      CustomToast('Maximum 100 questions can be added at a time', 'error');
      return;
    }

    if(from == 'qSet')
    {
      if (qSetId) {
        addQuestionsToExistingQSet(qSetId);
      } else {
        setOpenQsetCreateModal(true);
      }
    }
    else{
      if (assignmentId) {
        addQuestionsToExistingAssignment(assignmentId, true);
      } else {
        setOpenOptionTileModal(true);
      }
    }
  };

  const addQuestionsToExistingAssignment = async (existingAssignmentId, markInAssignment, assignedViaDetails) => {
    if (!props.selectedQuestions || props.selectedQuestions.filter(q => !q.inAssignment).length == 0) {
      return;
    }

    const selectedQuestionsInfoList = Object.values(props.selectedQuestions.filter(q => !q.inAssignment)).map(selectedQuestion => ({
      questionId: selectedQuestion.questionId,
      courseId: selectedQuestion.courseId
    }));

    let response = {};
    if (props.thumbnailType == 'mathSkill')
      response = await addMathSkillQuestionsAsync(existingAssignmentId);
    else
      response = await addCastleQuestions(existingAssignmentId, selectedQuestionsInfoList);

    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Questions are added', 'success');
      props.setSelectedQuestions([]);
      setOpenOptionTileModal(false);

      props.questionsList?.forEach(question => {
        const foundQuestion = selectedQuestionsInfoList.find(selectedQuestion => selectedQuestion.questionId === question.questionId);
        question.inAssignment = (markInAssignment && (question.inAssignment || foundQuestion)) ? true : false;
        question.isSelected = false;
      });

      if (assignmentAssignedViaDetails?.id == null && assignedViaDetails?.id != null)
        setAssignmentAssignedViaDetails({ assignedViaDetails });

      navigate('/assignments/' + existingAssignmentId + '/edit_assignment', { state: { assignedStatus: AssignmentStatus.NotAssigned, mcChoices: mcChoices } });
    }
  };

  const addQuestionsToExistingQSet = async (existingQSetId) => {
    if (!props.selectedQuestions || props.selectedQuestions.filter(q => !q.inAssignment).length == 0) {
      return;
    }

    const selectedQuestionsInfoList = Object.values(props.selectedQuestions.filter(q => !q.inAssignment)).map(selectedQuestion => ({
      questionId: selectedQuestion.questionId,
      courseId: selectedQuestion.courseId
    }));
  
    var response={};
    if (props.thumbnailType == 'mathSkill')
    {
      const options = {
        courseId: props.selectedCourseId,
        id: existingQSetId,
        questionIds: props.selectedQuestionIds
      };
      response = await addMathSkillQuestionsToQSet(options);
    }
    else
    { 
      var options = {
        id: existingQSetId,
        selectedQuestions: selectedQuestionsInfoList
      };
      response = await addCastleQuestionsToQSet(options);
    }

    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Questions are added', 'success');
      props.setSelectedQuestions([]);
      setOpenQsetCreateModal(false);
      navigate('/mycontent/questionsets/'+existingQSetId+'/questions');
    }
  };

  const handleApplyFilters = (questionsPerPage) => {
    var searchRequest = {
      keyword: props.keywords,
      pageNumber: 1,
      pageSize: questionsPerPage,
      courseIds: questionSearchContext.courseFilters.filter(f => f.isChecked).map(f => f.id),
      levels: questionSearchContext.levelFilters.filter(f => f.isChecked).map(f => f.id),
      multipleChoice: questionSearchContext.questionTypeFilters.filter((f) => f.id == 'mcCheckbox' && f.isChecked).length == 1,
      constructedResponse: questionSearchContext.questionTypeFilters.filter((f) => f.id == 'crCheckbox' && f.isChecked).length == 1,
      fillIn: questionSearchContext.questionTypeFilters.filter(f => f.id == 'fiCheckbox' && f.isChecked).length == 1,
      spanishOnly: questionSearchContext.translationFilters.filter(f => f.id == 'spQuestionsCheckbox' && f.isChecked).length == 1,
      includeTeacherContent: questionSearchContext.questionSourceFilters.filter(f => f.id == 'tQuestionsCheckbox' && f.isChecked).length == 1,
      includeCastleQuestions: questionSearchContext.questionSourceFilters.filter(f => f.id == 'cQuestionsCheckbox' && f.isChecked).length == 1,
      standards: questionSearchContext.standardFilters.filter(f => f.isChecked).map(f => f.id),
      teacherAssignmentIds: questionSearchContext.personalAssignmentFilters.filter(f => f.isChecked).map(f => f.id),
      publicAssignmentIds: questionSearchContext.publicAssignmentFilters.filter(f => f.isChecked).map(f => f.id),
      topics: questionSearchContext.topicFilters.filter(f => f.isChecked).map(f => f.id),
      tags: questionSearchContext.tagFilters.filter(f => f.isChecked).map(f => f.id),
      attributes: questionSearchContext.attributeFilters.filter(f => f.isChecked).map(f => f.id),
      teacherContentSetIds: questionSearchContext.teacherContentSetsFilter.filter(f => f.isChecked).map(f => f.id)
    };
    props.setCurrentSearchData({ ...searchRequest, searchType: 'filter' });
    props.filterCastleQuestionsCall(searchRequest).then((results) => { props.MapSearchResults(results); props.setSelectedPage(1); });
  };

  useEffect(() => {
    setSelectedQTypeFilter('all');
  }, [props.filterChange]);

  useEffect(() => {
    if (props.pageCount == 1 && props.thumbnailType != 'mathSkill') {
      props.setQuestionsPerPage(100);
      setDisableQuestionPerPages(true);
    }
    else
      setDisableQuestionPerPages(false);
  }, [props.pageCount]);

  const addCastleQuestions = async (existingAssignmentId, selectedQuestionsInfoList) => {
    var options = {
      id: existingAssignmentId,
      selectedQuestions: selectedQuestionsInfoList
    };
    const response = await addQuestions(options);
    return response;
  };

  const addMathSkillQuestionsAsync = async (existingAssignmentId) => {
    const options = {
      courseId: props.selectedCourseId,
      assignmentId: existingAssignmentId,
      questionIds: props.selectedQuestionIds
    };
    const response = await addMathSkillQuestions(options);
    return response;
  };

  const handleQTypeFilter = (qTypeValue) => {
    let updatedQuestionsList = [];
    switch (qTypeValue) {
    case 'all':
      updatedQuestionsList = props.originalQuestionsList;
      break;
    case 1:
    {
      let questionTypesToCheck = [QuestionTypes.MC, QuestionTypes.MultiCheckbox, QuestionTypes.MultiOption, QuestionTypes.DragDrop];
      updatedQuestionsList = props.originalQuestionsList.filter(question => questionTypesToCheck.includes(question.questionType));
      break;
    }
    case 2:
    case 3:
      updatedQuestionsList = props.originalQuestionsList.filter(question => question.questionType == qTypeValue);
      break;
    }
    setSelectedQTypeFilter(qTypeValue);
    props.setQuestionsList(updatedQuestionsList);
  };

  useEffect(() => {
    setSelectedQTypeFilter('all');
  }, [props.filterChange]);

  useEffect(() => {
    if (props.pageCount === 1) {
      props.setQuestionsPerPage(100);
      setDisableQuestionPerPages(true);
    }
    else
      setDisableQuestionPerPages(false);
  }, [props.pageCount]);

  return (
    <>
      <div className='selectionDetailsBar mt-5'>
        <div className='d-flex flex-row align-items-center'>
          <span className='fw-bold mr-2'>Selected:</span>
          <span id='all' className={`cursor-pointer ${selectedQTypeFilter == 'all' && 'fw-semibold clr-castleRed'}`} onClick={(e) => { handleQTypeFilter(e.target.id); }}>All</span><span className='selectionTypeCount'>{props.selectedQuestions.length}</span>
          <span id='mc' className={`${props.thumbnailType === 'mathSkill' ? '' : 'cursor-pointer'} selectionTypeLabel ${selectedQTypeFilter == 1 && 'fw-semibold clr-castleRed'}`} onClick={() => props.thumbnailType === 'mathSkill' ? '' : handleQTypeFilter(QuestionTypes.MC)}>Multiple Choice</span><span className='selectionTypeCount'>{props.selectedQuestions.filter(q => q.questionType == QuestionTypes.MC || q.questionType == QuestionTypes.MultiCheckbox || q.questionType == QuestionTypes.MultiOption || q.questionType == QuestionTypes.DragDrop).length}</span>
          <span id='fi' className={`cursor-pointer selectionTypeLabel ${selectedQTypeFilter == 2 && 'fw-semibold clr-castleRed'}`} onClick={() => handleQTypeFilter(QuestionTypes.FillIn)}>Fill-In</span><span className='selectionTypeCount'>{props.selectedQuestions.filter(q => q.questionType == QuestionTypes.FillIn).length}</span>
          <span id='cr' className={`${props.thumbnailType === 'mathSkill' ? '' : 'cursor-pointer'} selectionTypeLabel ${selectedQTypeFilter == 3 && 'fw-semibold clr-castleRed'}`} onClick={() => props.thumbnailType === 'mathSkill' ? '' : handleQTypeFilter(QuestionTypes.CR)}>Constructed Response</span><span className='selectionTypeCount'>{props.selectedQuestions.filter(q => q.questionType == QuestionTypes.CR).length}</span>
          <OverlayTrigger
            key="editToolTip"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">View all selected questions</Tooltip>}>
            <div className='selectionTypeCount questionsClipboard' onClick={() => props.thumbnailType === 'mathSkill' ? setShowMathSkillClipBoard(true) : setShowClipboardModal(true)}><FontAwesomeIcon icon={faClipboardList} /></div>
          </OverlayTrigger>

        </div>
        <div className='d-flex flex-row align-items-center'>
          <div className='d-flex flex-row align-items-center gap-2 my-2'>
            Questions Per Page:
            <DropdownButton id='dropdown-pageCount-selection' title={props.questionsPerPage} variant='castleDropdown' className={`me-2 ${disableQuestionPerPages && 'disable-Pointer-Events'}`} drop='down' onSelect={(e) => { if (e == props.questionsPerPage) return; props.setQuestionsPerPage(e); props.thumbnailType == 'mathSkill' ? '' : handleApplyFilters(e); }}>
              <Dropdown.Item eventKey='25' active={props.questionsPerPage == 25}>25</Dropdown.Item>
              <Dropdown.Item eventKey='50' active={props.questionsPerPage == 50}>50</Dropdown.Item>
              <Dropdown.Item eventKey='75' active={props.questionsPerPage == 75}>75</Dropdown.Item>
              <Dropdown.Item eventKey='100' active={props.questionsPerPage == 100}>100</Dropdown.Item>
            </DropdownButton>
          </div>
          {props.thumbnailType != 'mathSkill' && <PageNavigation handleSelectPage={handleSelectPage} currentPage={props.selectedPage} pageCount={props.pageCount} />}
          <div>
            <Button variant='castleRed' onClick={() => handleAddQuestions()} >Add Questions</Button>
          </div>
        </div>
      </div>

      {showClipboardModal &&
        <QuestionsClipboardModal
          showQuestionsClipboardModal={showClipboardModal}
          setShowQuestionsClipboardModal={setShowClipboardModal}
          selectedQuestions={props.selectedQuestions}
          setSelectedQuestions={props.setSelectedQuestions}
          setDateBasedKey={props.setDateBasedKey}
        />
      }

      {showMathSkillClipBoard &&
        <>
          <Modal
            isOpen={showMathSkillClipBoard}
            onClose={() => setShowMathSkillClipBoard(false)}
            titleName='Currently Selected Questions'
            contentWidth='60%'
          >
            {props.selectedQuestionIds.length <= 0 && <div className='d-flex flex-column align-items-center'>
              <div className='studentClipBoard'>
              </div>
              <span>
                You currently do not have any questions selected.
              </span>
            </div>}
            {props.selectedQuestionIds.length > 0 &&
              <MathSkillQuestionThumbnail
                questions={props.originalQuestionsList}
                setSelectedQuestionIds={props.setSelectedQuestionIds}
                selectedQuestionIds={props.selectedQuestionIds}
                setMathSkillQuestions={props.setSelectedQuestions}
                isLoading={false}
                showQuestionUsage={false}
                isSelectedOnly={true}
                selectedCourseId={-props.selectedCourseId}
              />
            }
          </Modal>
        </>
      }

      {openOptionTileModal &&
        <>
          <AddQuestionsToAssignment
            key={'component' + dateBasedKey}
            openOptionTileModal={openOptionTileModal}
            setOpenOptionTileModal={setOpenOptionTileModal}
            saveComponentCreate={saveComponentCreate}
            saveComponentAddToExisting={saveComponentAddToExisting}
          />
        </>
      }
      
      {openQsetCreateModal &&
        <>
          <CreateQuestionSetModel
            key={'createQSet' + dateBasedKey}
            isOpen={openQsetCreateModal}
            onClose={() => setOpenQsetCreateModal(false)}
            showQuestionOptions={false}
            onCreateSuccess={addQuestionsToExistingQSet}
          />
        </>
      }
    </>
  );
};

DetailsBar.propTypes = {
  questionsPerPage: PropTypes.number,
  setQuestionsPerPage: PropTypes.func,
  selectedQuestions: PropTypes.array,
  setSelectedQuestions: PropTypes.func,
  selectedPage: PropTypes.number,
  setSelectedPage: PropTypes.func,
  pageCount: PropTypes.number,
  getPageCastleQuestionsCall: PropTypes.func,
  MapSearchResults: PropTypes.func,
  dateBasedKey: PropTypes.string,
  setDateBasedKey: PropTypes.func,
  filters: PropTypes.object,
  keywords: PropTypes.string,
  setCurrentSearchData: PropTypes.func,
  filterCastleQuestionsCall: PropTypes.func,
  questionsList: PropTypes.array,
  setQuestionsList: PropTypes.func,
  originalQuestionsList: PropTypes.array,
  filterChange: PropTypes.bool,
  setSelectedQuestionIds: PropTypes.func,
  selectedQuestionIds: PropTypes.array,
  thumbnailType: PropTypes.string,
  selectedCourseId: PropTypes.number
};

export default DetailsBar;
